import type { ReactElement } from 'react'
import { useRef } from 'react'
import Immutable from 'immutable'
import cc from 'classcat'
import loadable from '@loadable/component'

const SettingsLayer = loadable(() => import(/* webpackChunkName: "editor" */ '../../SettingsLayer'))
const SettingsForm = loadable(() => import(/* webpackChunkName: "editor" */ './DividerSettings'))

export default function DividerPlugin({
  data = Immutable.fromJS({ dividerType: 'solid' }),
  editorMode,
  editorView,
  onCancel,
  onDataChange,
  onSave,
}: Readonly<WorkspacePluginProps>): ReactElement | null {
  const ref = useRef<HTMLDivElement>(null)
  const dividerType = data.get('dividerType')

  const pluginActiveClasses = cc([
    'dali-plugin-divider',
    {
      'dali-grid-element-highlighted': editorMode === 'edit',
    },
  ])

  const divider = <hr style={{ borderStyle: dividerType }} />

  if (editorView) {
    return (
      <div className={pluginActiveClasses} ref={ref}>
        {divider}
        <SettingsLayer open={editorMode === 'edit'} virtualRef={ref} side="right" onEscapeKeyDown={onCancel}>
          {({ renderLayout }) => <SettingsForm {...{ data, onDataChange, onSave, onCancel, renderLayout }} />}
        </SettingsLayer>
      </div>
    )
  }

  return !dividerType ? null : <div className={pluginActiveClasses}>{divider}</div>
}
